import loadable from '@loadable/component';

export const CategoryPage = loadable(/* #__LOADABLE__ */ () => import('./CategoryPage'));
